import { render, staticRenderFns } from "./siteMessages.vue?vue&type=template&id=008bf2ac&lang=pug&"
import script from "./siteMessages.vue?vue&type=script&lang=js&"
export * from "./siteMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports